import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=f0163966&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0163966')) {
      api.createRecord('f0163966', component.options)
    } else {
      api.reload('f0163966', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=f0163966&", function () {
      api.rerender('f0163966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8QsvB6paVxk0p/JS/stardisplay.vue"
export default component.exports